import React, { useState } from 'react';
import { Button, Textarea, Modal } from '@ontruck/orc';
import { injectIntl } from 'react-intl';
import PropTypes from 'prop-types';

const ReasonDeleteModal = ({ className, show, intl, onClose, onSave, content, disabled }) => {
  const t = intl.messages.components.VehicleEditModal;
  const [reason, setReason] = useState('');

  return (
    <Modal
      show={show}
      headerComponent={content?.title || t.delete_confirmation.title}
      size="M"
      closeButton={false}
      onClose={onClose}
      onTop={true}
    >
      <div className={className}>
        <div className="carrier-vehicle-delete-modal">
          <span className="carrier-vehicle-delete-modal__delete-content-text">
            {content?.text || t.delete_confirmation.text}
          </span>
          <Textarea
            id="delete_reason"
            name="delete_reason"
            label=""
            className="carrier-vehicle-delete-modal__delete-content-field"
            onChange={(e, { value }) => setReason(value)}
            labelType="hidden"
            placeholder={content?.field_text || t.delete_confirmation.field_text}
            height={'81px'}
          />
          <div className="carrier-vehicle-delete-modal__delete-content-actions">
            <Button
              onClick={() => onClose()}
              nude
              skin="secondary"
              size="M"
              text={content?.cancel || t.delete_confirmation.cancel}
            />
            <Button
              onClick={() => {
                onSave(reason);
                onClose();
              }}
              disabled={!reason || disabled}
              skin="primary"
              size="M"
              text={content?.remove || t.delete_confirmation.remove}
              data-testid="carrier-vehicle-delete-modal__button-remove"
            />
          </div>
        </div>
      </div>
    </Modal>
  );
};

ReasonDeleteModal.defaultProps = {
  content: undefined,
  disabled: false,
};

ReasonDeleteModal.propTypes = {
  intl: PropTypes.any,
  className: PropTypes.string,
  show: PropTypes.bool.isRequired,
  onSave: PropTypes.func.isRequired,
  content: PropTypes.object,
  disabled: PropTypes.bool,
};

export default injectIntl(ReasonDeleteModal);
